import { createSlice } from '@reduxjs/toolkit'

import {
    fetchBooks,
} from './extraReducers'

const slice = createSlice({
    name: 'books',
    initialState: {
        data: [] as any[],
        isLoading: false,
        isLoaded: false
    },
    reducers: {
        setBooksRoutine: (state, action) => {
            state.data = action.payload
        },
        clearBooksRoutine: (state) => {
            state.data = []
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchBooks.pending, (state) => {
                state.isLoading = true
                state.isLoaded = false
            })
            .addCase(fetchBooks.fulfilled, (state, action) => {
                state.data = action.payload as any
                state.isLoading = false
                state.isLoaded = true
            })
            .addCase(fetchBooks.rejected, (state) => {
                state.isLoading = false
                state.isLoaded = true
            })
    }
})

export const { setBooksRoutine, clearBooksRoutine} = slice.actions
export const booksDataSelector = (state: any) => state.books.data
export const booksIsLoadedSelector = (state: any) => state.books.isLoaded
export const booksIsLoadingSelector = (state: any) => state.books.isLoading
export default slice.reducer
